// Custom Progress Bars

import { Progress } from "antd";
import { useEffect, useRef, useState } from "react";


export const FakeProgressBar = ({ isFinished, ...properties }) => {
    const [percent, setPercent] = useState(0);
    const intervalRef = useRef(null);
    const stepRef = useRef(5); // starting step increment

    useEffect(() => {

        intervalRef.current = setInterval(() => {
            setPercent(prev => {
                if (prev >= 99) {
                    clearInterval(intervalRef.current);
                    if (!isFinished)
                        return 99; // stop just before 100 to simulate waiting
                    else {
                        // If finished, reset the step size for next use
                        stepRef.current = 5;
                        return 100; // complete the progress
                    }
                }

                // Decrease step size gradually
                const newStep = Math.max(0.1, stepRef.current * 0.95);
                stepRef.current = newStep;

                return Math.min(prev + newStep, 99);
            });
        }, 1000); // adjust for faster or slower perception

        return () => clearInterval(intervalRef.current);
    }, [isFinished]);

    return (
        <Progress percent={isFinished === true ? 100 : Math.floor(percent)} {...properties} />
    );
};